import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* globals google: true */


import queryString from 'query-string';
import { Promise } from 'es6-promise';
import EventEmitter from 'wolfy87-eventemitter';
var loading = false;
var events = new EventEmitter();

var loadGoogleMaps = function loadGoogleMaps(opts) {
  return new Promise(function (resolve) {
    if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
      resolve(google);
      return;
    }

    if (loading) {
      events.once('loaded', resolve);
      return;
    }

    loading = true;

    var options = _objectSpread({
      locale: 'en',
      apiKey: null,
      libraries: null
    }, opts);

    var timestamp = new Date().getTime();
    var callbackName = "initMap_".concat(timestamp);

    window[callbackName] = function () {
      resolve(google);
      events.emit('loaded', google);
    };

    var query = queryString.stringify({
      key: options.apiKey,
      callback: callbackName,
      libraries: options.libraries !== null ? options.libraries.join(',') : null,
      language: options.locale
    });
    var script = document.createElement('script');
    script.src = "https://maps.googleapis.com/maps/api/js?".concat(query);
    document.getElementsByTagName('head')[0].appendChild(script);
  });
};

export default loadGoogleMaps;